import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-taste",
  "use": "icon-leo-taste-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-taste\">\r\n<g transform=\"translate(-1781.760 -634.880) scale(4.480000)\">\r\n<path d=\"M448 160h128v96c128 32 224 144 224 288 0 176-128 320-288 320S224 720 224 544c0-144 96-256 224-288V160zm0 192c-96 24-160 112-160 192 0 128 96 224 224 224s224-96 224-224c0-80-64-168-160-192v-32h-128v32z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-taste.svg
// module id = 0AVW
// module chunks = 534